import React, {Component} from 'react';
import { Button, Form, Grid, Header, Icon, Modal, Segment, Label, Image, Table, Popup } from "semantic-ui-react";
import moment from "moment"
import { updateClerkComment } from '../../data/dashboard_api';
import {DropzoneComponent} from 'react-dropzone-component';
import 'react-day-picker/lib/style.css';
import 'rc-time-picker/assets/index.css';
import CreateAgentUser from "../user/agent/create_user";
import Loader from "../universal/loader";
import AssignClerk from "./assign_clerk";

class ViewQueryDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal:false,
            loggedComments:[],
            commentUpdates:[],
            attachments:[],
            uploadingComment:false,
            uploadedPics:[]
        };
    }

    componentWillMount() {

    }
    openEmail = (type = "") => {
        switch (type) {
            case "clerk":
                window.open(`mailto:${this.props.query.user.email}?subject=${this.props.query.property.address} - Customer Service Query&body=Hi %0D%0A%0D%0APlease review the system for the customer service query on this property and respond ASAP%0D%0A%0D%0AThanks`)
                break;
            case "company":
                window.open(`mailto:${this.props.query.inspection.report_email ? this.props.query.inspection.report_email : ""}?subject=${this.props.query.property.address} - Amended Inventory Report&body=Please find an amended inventory report attached%0D%0A%0D%0AThe report has been updated to reflect comments/images received from the tenant/landlord, which can be found at the back of the report%0D%0A%0D%0AIf there are any queries, please do let me know`)
                break;
            case "agent":
                window.open(`mailto:${this.props.query.inspection.agent_profile_report_email ? this.props.query.inspection.agent_profile_report_email : ""}?subject=${this.props.query.property.address} - Amended Inventory Report&body=Please find an amended inventory report attached%0D%0A%0D%0AThe report has been updated to reflect comments/images received from the tenant/landlord, which can be found at the back of the report%0D%0A%0D%0AIf there are any queries, please do let me know`)
                break;
            case "refer":
                window.open(`mailto:${this.props.query.validation_email}?subject=${this.props.query.property.address} - Customer Service Query&body=Thank you for your email.%0D%0A%0D%0AAre you aware of the breakdown of costs, if any, that are being suggested from the deposit by your Managing Agent/Landlord as yet? Our report is a direct comparison to the information available on the Check-In Report only. However, we will not consider any communication during the tenancy, or anything not mentioned in the Inventory Report.%0D%0A%0D%0AThe liability placed is a recommendation in line with arbitration guidelines only. However, it is at the Landlord's discretion as to whether to pursue any costs.%0D%0A%0D%0AI hope this is helpful. However, please let me know if there are any queries.%0D%0A%0D%0AThanks`)
                break;
            default:
                let csItemsText = ""
                this.props.query.customer_service_items.map(qItem =>{ qItem.visible? null: csItemsText += `The comment on "${encodeURIComponent(qItem.name)}" - "${encodeURIComponent(qItem.comments) || ""}" has not been included due to the following clerk reply: "${encodeURIComponent(qItem.clerk_comments) || ""}"%0D%0A%0D%0A`})
                let encodedString = `mailto:${encodeURIComponent(this.props.query.validation_email)}?subject=${encodeURIComponent(this.props.query.property.address)} - Inventory Report&body=Hello%0D%0A%0D%0AThank you for your email%0D%0A%0D%0AThe Report has been updated with the comments and re-sent onto your letting agent, for redistribution%0D%0A%0D%0A${csItemsText}  %0D%0A%0D%0AKind regards`
                let decodedString = decodeURIComponent(encodedString);
                navigator.clipboard.writeText(decodedString)
                window.open(encodedString)
                break;
        }
    }
    setCurrentImage = (image) => {
        this.setState({ currentImage: image, showModal: true})
    }
    uploadClerkComment = async (item = undefined) => {
        this.setState({uploadingComment:true})
        let formData = new FormData()
        let picsToAdd=[]
        if(item) {
            formData.append("item_comment", this.state.item_comment || "") 
            formData.append("client_id",item.client_id)
            formData.append("id",item.id)
            this.state.attachments.forEach((file) => {
                formData.append("images[]", file);
                picsToAdd.push( {client_id:item.client_id,file:file})
                });
        } else {   
            formData.append("clerk_comment", this.state.clerk_comment || "")
        }
        formData.append("query_id", this.props.query.id)
        updateClerkComment(formData).then(() =>{
            if(item) {
            this.setState({
                uploadingComment:false,
                attachments:[],
                loggedComments:[...this.state.loggedComments, item.client_id],
                commentUpdates:[...this.state.commentUpdates,this.state.item_comment],
                uploadedPics:[...this.state.uploadedPics,...picsToAdd]
            })}
            else {this.props.refreshData()}
        })
    }

     removingFile = (file) => {
        let attachments = this.state.attachments;
        if (attachments.indexOf(file) !== -1) {
            attachments.splice(attachments.indexOf(file), 1);
        }
        return attachments;
    };

    

    render() {

        let dropZone = null;
                const componentConfig = {postUrl: 'no-url'};
                const djsConfig = {autoProcessQueue: false, addRemoveLinks: true,acceptedFiles:"image/*"}
                const eventHandlers = {
                    init: (dropzone) => {
                        dropZone = dropzone;
                    },
                    addedfile: (file) => {
                        this.setState({attachments: [...this.state.attachments, file]})
                    },
                    removedfile: (file) => {
                        this.setState({attachments: this.removingFile(file)});
                    },
                };

                
        const status = {
            "pending": 'Pending',
            "awaiting_admin_review": 'Awaiting Admin Review',
            "awaiting_clerk_reply": 'Awaiting Clerk Reply',
            "closed": 'Closed'
        };
        return (<React.Fragment>
            <Modal onClose={() => this.setState({ showModal: false })} open={this.state.showModal} size="fullscreen" style={{ height: "95%",overflow:"scroll"}}>
                <Modal.Content image style={{ height: "100%" }}>
                    <div className="modal-close-button">
                        <Button negative icon onClick={(e) => {this.setState({ showModal: false });}}>
                  <Icon name="close" />
                </Button>
              </div>
            <Image rounded centered style={{ height: this.state.zoom + "%", width: "auto",maxWidth:this.state.zoom+"%" }} src={this.state.currentImage? this.state.currentImage.image_path:null} />
            </Modal.Content>
          </Modal>
            <Segment textAlign="center">
                <Grid stackable columns={3} className="minTop-margin left-aligned" style={{ marginTop: '0.5em' }}>
                      {this.props.userRole === "admin" &&
                    <Grid.Row>
                        <Grid.Column>
                                <Button icon onClick={() => (this.openEmail())}> <Icon name="mail" />Email Reply</Button>
                                <Button icon onClick={() => (this.openEmail("company"))}> <Icon name="mail" />Email Company</Button>
                                {this.props.query.inspection.agent_profile_report_email && <Button icon onClick={() => (this.openEmail("agent"))}> <Icon name="mail" />Email Agent</Button>}
                                <Button icon onClick={()=>(this.openEmail("clerk"))}> <Icon name="mail" />Email Clerk</Button>
                                <Button icon onClick={() => (this.openEmail("refer"))}> <Icon name="mail" />Email Refer Agent</Button>
                        </Grid.Column>
                    </Grid.Row>}
                    <Grid.Row stretched>
                        <Grid.Column width={7}>
                            <Segment>
                                <Label color='blue' ribbon>
                                    Query Details
                                </Label><p />
                                <dl>
                                    <dt>Querier Name</dt>
                                    <dd>{this.props.query.querier_name}</dd>
                                    <dt>Querier Relation</dt>
                                    <dd>{this.props.query.querier_relation}</dd>
                                    <dt>Querier Email</dt>
                                    <dd>{this.props.query.validation_email}</dd>
                                    <dt>Query Type</dt>
                                    <dd style={{ textTransform: "capitalize" }}>{this.props.query.query_type}</dd>
                                    <dt>Query Status</dt>
                                    <dd style={{ textTransform: "capitalize" }}>{status[this.props.query.status]}</dd>
                                    <dt>Identity Validated</dt>
                                    <dd style={{ textTransform: "capitalize" }}>{this.props.query.email_validated?"Yes" : "No"}</dd>
                                    {this.props.userRole === "admin" && <dt>CS Points</dt>}
                                    {this.props.userRole === "admin" && <dd style={{ textTransform: "capitalize" }}>{this.props.query.severity_points ? this.props.query.severity_points : 0}</dd>}
                            </dl></Segment>
                        </Grid.Column>
                        <Grid.Column width={9} >
                            <Segment>
                            <Label color='blue' ribbon>
                                    General Query Comment
                                </Label><p /><p />
                        {this.props.query.query_comment.split("\n").map((value, index) => {return (<React.Fragment key={index}>{value}<br /></React.Fragment>);})}
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>

                    {this.props.userRole === "admin" && <Grid.Row style={{minHeight:"150px"}} stretched>
                        <Grid.Column >
                            <Segment>
                                <Label color='blue' ribbon>
                                    Clerk Comment
                                </Label><p />
                                {this.props.query.clerk_comment && this.props.query.clerk_comment.split("\n").map((value, index) => { return (<React.Fragment key={index}>{value}<br /></React.Fragment>); })}
                            </Segment>
                        </Grid.Column>
                        <Grid.Column >
                            <Segment >
                                <Label color='blue' ribbon>
                                    Admin Comment
                                </Label><p />
                                {this.props.query.admin_comment && this.props.query.admin_comment.split("\n").map((value, index) => { return (<React.Fragment key={index}>{value}<br /></React.Fragment>); })}
                            </Segment>
                        </Grid.Column>
                        <Grid.Column >
                            <Segment>
                                <Label color='blue' ribbon>
                                    Conclusion Notes
                                </Label><p />
                                {this.props.query.conclusion_notes && this.props.query.conclusion_notes.split("\n").map((value, index) => { return (<React.Fragment key={index}>{value}<br /></React.Fragment>); })}
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>}

                    {this.props.userRole === "clerk" && <Grid.Row style={{minHeight:"150px"}} stretched>
                        <Grid.Column width={8} >
                            <Segment>
                                <Label color='blue' ribbon>
                                    Clerk Comment
                                </Label><p />
                                {this.props.query.clerk_comment && !this.state.showClerkEditComment && this.props.query.clerk_comment.split("\n").map((value, index) => { return (<React.Fragment key={index}>{value}<br /></React.Fragment>); })}
                                {this.props.query.status === "awaiting_clerk_reply" || this.props.query.status==="awaiting_admin_review" ? <React.Fragment>{this.state.showClerkEditComment ? <Form><Form.TextArea name="clerk_comment" onFocus={(e) =>{this.setState({ clerk_comment: e.target.value }) }} onChange={(e) => { this.setState({ clerk_comment: e.target.value }) }} defaultValue={this.state.clerk_comment} />
                                    <div className="submit-buttons">
                                    <p></p><Button type="submit" primary content="Upload Comment" onClick={() => { this.uploadClerkComment(); }} />
                                </div></Form> : <div className="submit-buttons">
                                    <p></p><Button type="submit" primary content="Edit Comment" onClick={() => { this.setState({ showClerkEditComment: true,clerk_comment:this.props.query.clerk_comment,attachments:[] }) }} />
                                </div>}</React.Fragment>:null}
                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8} >
                            <Segment >
                                <Label color='blue' ribbon>
                                    Admin Comment
                                </Label><p />
                                {this.props.query.admin_comment && this.props.query.admin_comment.split("\n").map((value, index) => { return (<React.Fragment key={index}>{value}<br /></React.Fragment>); })}
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>}
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment attached>
                                <Header>General Query Photos</Header>
                                <Image.Group size="small">
                                {this.props.query.customer_service_query_images && this.props.query.customer_service_query_images.map((image) => {
                                    return (image.image_path && <Image key={image.id}
                                        style={{ cursor: "pointer" }}
                                        className="grow"
                                        onClick={() => {
                                            this.setCurrentImage(image)
                                        }}
                                        rounded
                                        src={image.image_path}
                                        target="_blank"
                                    />)
                                })}
                      </Image.Group>
                            </Segment>
                            </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            {this.props.query.customer_service_items.length > 0 &&<Segment>
                                <Header>Item Comments</Header>
                                {this.props.query.customer_service_items.map((csItem) => {return <Segment key={csItem.client_id}>
                                    <Table style={{marginBottom:"15px"}}  fixed celled compact>
                                        <Table.Body>
                                      <Table.Row>
            <Table.Cell><strong>Index & Location</strong></Table.Cell>
            <Table.Cell colSpan={4}>
            {(csItem.visible? <Button onClick={(e)=>{e.preventDefault()}} compact basic  size="mini">Visible</Button>: <Button onClick={(e)=>{e.preventDefault()}} compact basic color="red" size="mini">Not Visible</Button>)}
            <Button primary compact basic size="mini" onClick={(e)=>{e.preventDefault()}}><Icon name="hashtag"></Icon>{csItem.item_index}</Button>
            <Button onClick={(e)=>{e.preventDefault()}} compact basic color="green" size="mini">{csItem.room}</Button>
            <Button onClick={(e)=>{e.preventDefault()}} compact basic color="orange" size="mini">{csItem.group}</Button></Table.Cell>
        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell><strong>Item Description</strong></Table.Cell>
                                            <Table.Cell colSpan={4}>{csItem.name}</Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell><strong>CI Notes</strong></Table.Cell>
                                            <Table.Cell colSpan={4}>{csItem.ci_notes || "None"}</Table.Cell>
                                        </Table.Row>
                                        {this.props.query.inspection.inspection_type == "co" && <Table.Row>
                                            <Table.Cell><strong>CO Notes</strong></Table.Cell>
                                            <Table.Cell colSpan={4}>{csItem.co_notes || "None"}
                                            {csItem.flag && <Button onClick={e =>{e.preventDefault()}}compact size="mini" basic color="orange">{csItem.flag}</Button>}
            {csItem.additional_notes.length > 0 ?<Popup trigger={<Button icon="list" labelPosition='left' compact size="mini" content={"Additional Notes"} basic onClick={e =>{e.preventDefault()}} color="grey"/>}>
                <ul>{csItem.additional_notes.map((note) =>{return <li>{note.co_notes} {note.flag && <Button onClick={e =>{e.preventDefault()}}compact size="mini" basic color="orange">{note.flag}</Button>} </li>})}</ul>
            </Popup>:null}</Table.Cell>
                                        </Table.Row>}
                                        <Table.Row>
                                            <Table.Cell><strong>Item Query Comment</strong></Table.Cell>
                                            <Table.Cell colSpan={4}>{(csItem.comments || "").split("\n").map((value, index) => {return (<React.Fragment key={index}>{value}<br /></React.Fragment>);})}</Table.Cell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.Cell><strong>Clerk Comment</strong></Table.Cell>
                                            <Table.Cell colSpan={4}>{
                                                this.state.loggedComments.includes(csItem.client_id) ? <span>{this.state.commentUpdates[this.state.loggedComments.indexOf(csItem.client_id)]}</span> :<React.Fragment>{this.state.showClerkItemEdit != csItem.client_id ? (csItem.clerk_comments || "").split("\n").map((value, index) => {return (<React.Fragment key={index}>{value}<br /></React.Fragment>);}):null}
                                {this.props.query.status === "awaiting_clerk_reply" || this.props.query.status==="awaiting_admin_review" ? <React.Fragment>{this.state.showClerkItemEdit == csItem.client_id ? <Form><Form.TextArea label="Comment" name="clerk_comment" onFocus={(e) =>{this.setState({ item_comment: e.target.value }) }} onChange={(e) => { this.setState({ item_comment: e.target.value }) }} defaultValue={csItem.clerk_comments} /> 
                                    <Form.Field label="Supporting Images"></Form.Field>
                                                                       <DropzoneComponent config={componentConfig}
                                                        eventHandlers={eventHandlers}
                                                        djsConfig={djsConfig}/> <div className="submit-buttons">
                                    <p></p><Button type="submit" loading={this.state.uploadingComment} disabled={this.state.uploadingComment} primary content="Upload Comment" onClick={() => { this.uploadClerkComment(csItem); }} />
                                </div></Form> : <div className="submit-buttons">
                                    <p></p><Button type="submit" primary content="Edit Comment" onClick={() => {;this.setState({ showClerkItemEdit: csItem.client_id,item_comment:csItem.clerk_comments }) }} />
                                </div>}</React.Fragment>:null}</React.Fragment>}
                                                </Table.Cell>
                                        </Table.Row>
                                        </Table.Body>
                                        </Table>
                                        <Header as="h5">Item Query Images</Header>
                                <Image.Group size="small">
                                {csItem.customer_service_item_images && csItem.customer_service_item_images.map((image) => {
                                    if (image.image_type !="reply") {
                                    return (image.image_path && <Image key={image.id}
                                        style={{ cursor: "pointer" }}
                                        className="grow"
                                        onClick={() => {
                                            this.setCurrentImage(image)
                                        }}
                                        rounded
                                        src={image.image_path}
                                        target="_blank"
                                    />)
                                }})}
                      </Image.Group>
                          <Header as="h5">Clerk Comment Images</Header>
                                <Image.Group size="small">
                                {csItem.customer_service_item_images && csItem.customer_service_item_images.map((image) => {
                                    if (image.image_type =="reply") {
                                    return (image.image_path && <Image key={image.id}
                                        style={{ cursor: "pointer" }}
                                        className="grow"
                                        onClick={() => {
                                            this.setCurrentImage(image)
                                        }}
                                        rounded
                                        src={image.image_path}
                                        target="_blank"
                                    />)
                                }}
                                )}

                            {this.state.uploadedPics.map((image) => {
                                    if (image.client_id ==csItem.client_id) {
                                    return (image.file.dataURL && <Image key={image.file.upload.uuid}
                                        style={{ cursor: "pointer" }}
                                        className="grow"
                                        rounded
                                        src={image.file.dataURL}
                                        target="_blank"
                                    />)
                                }}
                                )}

                      </Image.Group>
                      </Segment>})}
                            </Segment>}
                            </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
                        
            </React.Fragment>);
    }
}

export default ViewQueryDetail;


// WEBPACK FOOTER //
// ./src/views/inspection/view_query_detail.js